import { useNavigate } from "react-router-dom";
import styles from "./SectionSheet.module.css";

export default function SectionSheet({ section, onClose, onItemExterno }) {
    const navigate = useNavigate();

    function handleItem(item) {
        if (item.rota) {
            // Mesmo mecanismo do item tipo 'conteudo' logo abaixo - a página de
            // destino lê o header (título/ícone/subtítulo) do state da navegação
            // em vez de ter texto fixo (pedido do usuário, 2026-10-07: "vem do
            // que eu coloco em título e subtítulo e ícone no cozimaxerp").
            navigate(item.rota, { state: { titulo: item.label, icone: item.icon, subtitulo: item.subtitulo } });
        } else if (item.conteudo) {
            // Item tipo 'conteudo': não navega pra fora nem por rota fixa - abre a
            // tela de conteúdo passando o que já veio junto no menu (texto/imagem),
            // sem precisar buscar de novo (ver MenuContext.jsx/normalizar). Sempre
            // cai no mesmo "/menu-conteudo" genérico, então o nav (BottomNav) não
            // consegue saber por pathname a qual seção pertence - onItemExterno avisa.
            onItemExterno?.();
            navigate("/menu-conteudo", { state: { item: item.conteudo, titulo: item.label, icone: item.icon } });
        } else {
            // Link externo: abre em nova aba, o pathname do app não muda em nada -
            // onItemExterno avisa o BottomNav pra destacar a seção manualmente.
            onItemExterno?.();
            window.open(item.url, "_blank");
        }
        onClose();
    }

    return (
        <>
            <div className={styles.overlay} onClick={onClose} />
            <div className={styles.sheet}>
                <div className={styles.handle} />
                <div className={styles.header}>
                    <span className={styles.headerIcon}>{section.icon}</span>
                    <h3 className={styles.headerTitle}>{section.section}</h3>
                </div>
                <div className={styles.items}>
                    {section.items.map((item) => (
                        <div
                            key={item.label}
                            className={styles.item}
                            onClick={() => handleItem(item)}
                        >
                            <span className={styles.itemIcon}>{item.icon}</span>
                            <span className={styles.itemLabel}>{item.label}</span>
                            {item.url && <span className={styles.itemArrow}>↗</span>}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
